<template>
  <v-layout v-if="show">
    <v-chart :style="style" :options="charts"/>
  </v-layout>
</template>

<script> 
export default {
  props:["not","notShow","notChartType","notUnit","notHeight","notWidth","notColors","notChartData"],
  data: () => ({
    show:false, 
     
  }),
  mounted() { 
    this.show = false
    setTimeout(() => {
      this.show = this.notShow
    }, 100); 
    //console.log(this.notChartData,this.notUnit);
    
  },
  computed: {
    vs(){
      return this.not.vs
    },
    vs_width(){
      return this.vs.width
    },
    style(){
      let h = "400px"
      let w = "100%"
      if (this.notWidth) {
        w = this.notWidth
      }
      if (this.notHeight) {
        h=this.notHeight
      }
      return "width: "+w+"; height:"+h+";"
    },
    charts(){ 
      let data =   this.notChartData
      if (this.notUnit==="Percentage") {
        data = this.percentage(data)
      }else if (this.notUnit==="%") {
        data = this.percentage(data)
      }
      let chartData = this.combination(data) 
      let ch = this.processChart(chartData)
      return ch
    }, 
    candidates(){
        return this.$store.getters.getCandidates
    }, 
    JOINED_candidates(){
      let candidates = this.not.JOIN_CANDIDATES(this.candidates)
      return candidates.sort(this.not.dynamicSort('party_short_name')) 
    }

  },
  methods:{
    percentage(data){
      if (!data) {
        return null
      }

      let TOTAL = 0 
      data.forEach(it => {
        TOTAL = TOTAL+(it.value*1)
      });
      data.forEach(it => {
        let t = (it.value*100)/TOTAL
        it.value = t.toFixed(2);
      });
      return data
    },
    processChart(barData){  
      let  chart = {
        color: barData.color,
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        legend: {
            //data: ['Steppe', 'Desert', 'Wetland']
            data:barData.itemsLable
        },
        toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
                mark: {
                    show: true,
                    title: {
                        mark: 'Markline switch',
                        markUndo: 'Undo markline',
                        markClear: 'Clear markline'
                    }
                },
                dataView: {
                    show: true,
                    readOnly: false,
                    title: 'View data',
                    lang: ['View chart data', 'Close', 'Update']
                },
                magicType: {
                  show: true,
                  title: {
                      line: 'Switch to line chart',
                      bar: 'Switch to bar chart',
                      stack: 'Switch to stack chart',
                      tiled: 'Switch to tiled chart'

                  },
                  type: ['line', 'bar', 'stack', 'tiled']},
                restore: {
                    show: true,
                    title: 'Restore'
                },
                saveAsImage: {
                    show: true,
                    title: 'Same as image',
                    lang: ['Save']
                }
            }
        },
        xAxis: [
            {
                type: 'category',
                axisTick: {show: false},
                data: barData.labels,
                axisLabel: {
                    interval: 0,
                    rotate: 20,
                },
            }
        ],
        yAxis: [
            {
                type: 'value'
            }
        ],
        series: barData.items
      }
      return chart;
    }, 
    calculate_items(data){
      let candidates = this.JOINED_candidates
      if(!data){return}
      if(!candidates){return}
      let labelOption = {
          show: true,
          position: 'insideBottom',
          distance: 15,
          align: 'left',
          verticalAlign: 'middle',
          rotate: 90,
          formatter: '{c}  {name|{a}}',
          fontSize: 16,
          rich: {
              name: {
                  textBorderColor: '#fff'
              }
          }
      };
      let items = []
      candidates.forEach(candidate => {
        //get location data
        let votes = []
        let percent_votes = []
        data.forEach(element => {
          let c1 = element.candidates
          c1.forEach(c2 => {
            if (c2.code === candidate.code) {
              votes.push(c2.votes)
              percent_votes.push(c2.percent_votes.toFixed(2)) 
            }
          });
        });
        items.push({
          name: candidate.party_short_name,
          type: 'bar',
          barGap: 0,
          label: labelOption,
          data:this.notUnit==="Percentage"?percent_votes:votes,
          data2:votes,
        })
      });
      return items
    },
    combination(chartData){
        let candidates = this.JOINED_candidates
        if (!chartData) {return null} 
        if (!candidates) {return null} 
        let labels = []
        let color = []
        let itemsLable =[]
        let items =  this.calculate_items(chartData) 

        //color 
        candidates.forEach(candidate => { 
          if (candidate.party) {
            color.push(candidate.party.color_code) 
          }
        });
        //item lables
        candidates.forEach(candidate => {  
          itemsLable.push(candidate.party_short_name)  
        }); 

        //LABLES
        chartData.forEach(it => {
          labels.push(this.not.TEXT_UP(it.name+' ('+it.votes+')')) 
        });  
        return {
          labels:labels,
          collection:chartData,
          color:color,
          items:items,
          itemsLable:itemsLable
        };
    }
  },
  watch: {
    notShow(v){
      this.show =v
    },
    notHeight(v){
      this.show = false
      setTimeout(() => {
        this.show = this.notShow
      }, 100); 
    },
    notChartData(v){ 
      // this.show = false
      // setTimeout(() => {
      //   this.show = this.notShow
      // }, 100); 
    },
    vs_width(v){
      this.show = false
      setTimeout(() => {
        this.show = this.notShow
      }, 100); 
    }
  },
};
</script>
